// TrainersGallery.jsx
import { useState, useRef, useCallback } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "../../hooks/useTranslation";
import TrainerModal from "../../components/trainers/TrainerModal";

// import all trainer images in this folder
const trainerImages = require.context(
    "../../assets/images/trainers",
    false,
    /\.(png|jpe?g|svg)$/
);

const getImage = (filename) => {
    if (!filename) return null;
    try {
        return trainerImages(`./${filename}`);
    } catch {
        return null;
    }
};

const normalizeEmail = (value = "") =>
    !value ? "" : value.startsWith("mailto:") ? value : `mailto:${value}`;

const normalizeInsta = (value = "") => {
    if (!value) return "";
    if (/^https?:\/\//i.test(value)) return value;
    const handle = value.replace(/^@/, "");
    return `https://instagram.com/${handle}`;
};

export default function TrainersGallery() {
    const t = useTranslation();
    const [active, setActive] = useState(null);
    const cardsRef = useRef({});

    // full trainers object from the current language pack
    const trainersConfig = t("trainers.list");

    // build an array from the JSON so we can map over it
    const trainers = Object.entries(trainersConfig)
      .filter(([, data]) => data.active !== false)
      .map(
        ([key, data], index) => ({
            id: index + 1,
            key,
            name: data.name,
            bio: data.bio,
            img: getImage(data.image),
            phone: data.phone || "",
            mail: normalizeEmail(data.email || ""),
            insta: normalizeInsta(data.instagram || "")
        })
      );

    const label = (k) => t(`trainers.labels.${k}`);

    const handleClose = useCallback(() => {
        setActive(null);
        setTimeout(() => {
            cardsRef.current[active?.id]?.focus?.({ preventScroll: true });
        }, 0);
    }, [active]);

    return (
        <section id="trainers-section">
            <Container className="trainers-container">
                <Row className="trainer-row g-4 justify-content-center">
                    {trainers.map((tr) => (
                        <Col
                            className="trainer-col align-items-center justify-content-center"
                            key={tr.id}
                            md={12}
                            lg={6}
                            xl={4}
                            xxl={4}
                        >
                            <Card
                                className="trainer-card glass-trainer"
                                onClick={() => setActive(tr)}
                                tabIndex={0}
                                onKeyUp={(e) =>
                                    e.key === "Enter" && setActive(tr)
                                }
                                ref={(el) => (cardsRef.current[tr.id] = el)}
                            >
                                <div className="trainer-box">
                                    <Card.Img
                                        src={tr.img}
                                        alt={tr.name}
                                        className="trainer-photo"
                                        loading="lazy"
                                    />
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>

            <TrainerModal
                trainer={active}
                labels={label}
                name={(slug) => trainersConfig?.[slug]?.name || ""}
                bio={(slug) => trainersConfig?.[slug]?.bio || ""}
                onClose={handleClose}
            />
        </section>
    );
}
